import Vue from 'vue';

export default Vue.extend({
  name: 'ListMixin',

  methods: {
    isEditingRow(listPk: number, editingPk?: number): boolean {
      return editingPk === listPk;
    },
    editingRowCss(listPk: number, editingPk?: number): string {
      return this.isEditingRow(listPk, editingPk) ? 'editingRow' : '';
    },
  },
});
